import React, { useState } from 'react';
import './App.css';
import CaseList from './pages/CaseList';
import CaseDetail from './pages/CaseDetail';
import Dashboard from './pages/Dashboard';
import { mockCases } from './data/mockData';

export default function App() {
    const [currentPage, setCurrentPage] = useState('dashboard'); // dashboard, list, detail
    const [selectedCaseId, setSelectedCaseId] = useState(null);

    const handleCaseClick = (caseId) => {
        setSelectedCaseId(caseId);
        setCurrentPage('detail');
    };

    const handleBackToDashboard = () => {
        setCurrentPage('dashboard');
    };

    const handleViewCaseList = () => {
        setCurrentPage('list');
    };

    return (
        <div className="app">
            <header className="navbar">
                <h1>🚚 FedEx DCA Management Platform</h1>
                <div className="nav-buttons">
                    <button onClick={handleBackToDashboard} className="nav-btn">Dashboard</button>
                    <button onClick={handleViewCaseList} className="nav-btn">Cases</button>
                </div>
            </header>

            <main>
                {currentPage === 'dashboard' && <Dashboard onCaseClick={handleCaseClick} onViewCases={handleViewCaseList} />}
                {currentPage === 'list' && <CaseList cases={mockCases} onCaseClick={handleCaseClick} />}
                {currentPage === 'detail' && <CaseDetail caseId={selectedCaseId} onBack={handleBackToDashboard} />}
            </main>
        </div>
    );
}
